import { render, staticRenderFns } from "./saveTemp.vue?vue&type=template&id=32d96442&scoped=true&"
import script from "./saveTemp.vue?vue&type=script&lang=js&"
export * from "./saveTemp.vue?vue&type=script&lang=js&"
import style0 from "./saveTemp.vue?vue&type=style&index=0&id=32d96442&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d96442",
  null
  
)

export default component.exports